import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();

  const rolLabel = {
    admin: 'Administrador',
    residente: 'Residente',
    vigilante: 'Vigilante'
  };

  const rolClass = {
    admin: 'rol-admin',
    residente: 'rol-residente',
    vigilante: 'rol-vigilante'
  };

  const initial = user?.nombre_completo?.charAt(0)?.toUpperCase() || 'U';

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <div className="brand-icon">🏢</div>
        <span>Control Visitas</span>
      </div>
      <div className="navbar-right">
        <span className={`rol-badge ${rolClass[user.rol]}`}>
          {rolLabel[user.rol]}
        </span>
        <button className="btn-logout" onClick={logout}>
          Salir
        </button>
      </div>
    </nav>
  );
}